<template>
	<div class="container">
		<canvas ref="canvas"></canvas>
	</div>
</template>

<script setup>
import Scene from './Scene.js'
import { Three } from '@buro/gl'
import { useEmitter } from '~/composables/core'

import { gsap, ScrollTrigger } from 'gsap/all'
import.meta.client && gsap.registerPlugin(ScrollTrigger)

const canvas = ref()
const three = ref()

const emitter = useEmitter()

const init = () => {
	try {
		three.value = Three.createApp(canvas.value, {
			gl: {
				alpha: true,
				webGPU: true,
				// forceWebGL: true,
			},
			camera: {
				fov: 45,
				position: [0, 0, 12],
			},
			observe: false,
			// frameloop: 'none',
		})

		three.value.render(() => Scene(emitter))
	} catch (error) {
		emitter.emit('webgl-error')
		console.error('error setting up webgl:', error)
	}
}

onMounted(() => {
	init()
})

onBeforeUnmount(() => {})

onUnmounted(() => {
	three.value?.dispose()
})
</script>

<style lang="scss" scoped>
.container {
	pointer-events: none;
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100lvh;
	z-index: 10;
	canvas {
		width: 100%;
		height: 100%;
	}
}
</style>
